import { render, staticRenderFns } from "./editDealer.vue?vue&type=template&id=34bde047&scoped=true"
import script from "./editDealer.vue?vue&type=script&lang=js"
export * from "./editDealer.vue?vue&type=script&lang=js"
import style0 from "./editDealer.vue?vue&type=style&index=0&id=34bde047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bde047",
  null
  
)

export default component.exports